import type { StripeCustomerData } from '../../repositories';
import { StripePriceVO } from '../price';

type UpcomingInvoiceData = NonNullable<StripeCustomerData['upcomingInvoice']>;

export class StripeUpcomingInvoice {
  constructor(private readonly values: UpcomingInvoiceData) {}

  public toJson() {
    return this.values;
  }

  public getPeriodStart() {
    return new Date(this.values.periodStart * 1000);
  }

  public getPeriodEnd() {
    return new Date(this.values.periodEnd * 1000);
  }

  public getAmountDue() {
    return new StripePriceVO(this.values.amountDue / 100, this.values.currency);
  }
}
